export default "/images/profile-banner.jpg?36e234be13c92b9c521564a065ad5503";